import { normalizeVaultMenuRouteKey } from './vault-menu-canonical.snapshot';

/** Rutas canónicas por clave de opción Simappe (menú API). */
export const VAULT_OPTION_KEY_TO_CANONICAL_ROUTE: Record<string, string> = {
  OPTIONS_VAULT_DASHBOARD: '/layout/vault/dashboard',
  OPTIONS_VAULT_INGEST: '/layout/vault/vault/projects',
  OPTIONS_VAULT_PRESERVATION: '/layout/vault/preservation',
  OPTIONS_VAULT_RETENTION: '/layout/vault/retention',
  OPTIONS_VAULT_LEGAL_HOLD: '/layout/vault/legal-hold',
  OPTIONS_VAULT_REPOSITORIO_ADMIN: '/layout/vault/repository-admin',
  OPTIONS_VAULT_REPORTS: '/layout/vault/reports',
  OPTIONS_VAULT_CLOUD: '/layout/vault/cloud',
  OPTIONS_VAULT_AUDIT: '/layout/vault/audit',
  OPTIONS_VAULT_SETTINGS: '/layout/vault/settings',
  OPTIONS_VAULT_PRESERVATION_MESSAGES: '/layout/vault/preservation-messages',
  OPTIONS_VAULT_NOTIFICATIONS: '/layout/vault/notifications',
  OPTIONS_VAULT_ADMIN_TENANTS: '/layout/vault/admin/tenants',
  OPTIONS_VAULT_ADMIN_USERS: '/layout/vault/admin/user',
  OPTIONS_VAULT_ADMIN_USER: '/layout/vault/admin/user',
  OPTIONS_VAULT_ADMIN_MODULE_PERMISSIONS: '/layout/vault/admin/permissions',
};

export function expandAllowedRouteKeysFromApiOptions(
  keys: Set<string>,
  optionKeys: Iterable<string>,
): Set<string> {
  const expanded = new Set(keys);
  for (const optionKey of optionKeys) {
    const canonical = VAULT_OPTION_KEY_TO_CANONICAL_ROUTE[optionKey];
    if (!canonical) continue;
    const normalized = normalizeVaultMenuRouteKey(canonical);
    if (normalized) expanded.add(normalized);
  }
  return expanded;
}
